<template>
    <b-modal
        v-model="modal"
        :id="'bars-details-modal'"
        :ref="'bars-details-modal'"
        :title="$t('survey.result_details')"
        :ok-title="$t('common.close')"
        ok-only
        size="lg"
        modal-class="apprentice-default-modal">
        <div v-if="modal">
            <apexcharts
                type="line"
                :options="chartOptions"
                :series="series"
                height="300px"></apexcharts>

            <div
                class="skill-bar col-6"
                v-for="form in forms"
                v-if="form.values !== undefined"
                :key="form.id">
                <div class="row">
                    <div class="col-10">
                        <p>{{ form.created_at | date_named_month_short }}</p>
                        <b-progress max="100">
                            <b-progress-bar
                                variant="primary"
                                :value="form.values.self.value"
                                :label="form.values.self.value + '%'"></b-progress-bar>
                        </b-progress>
                        <b-progress
                            class="skill-bar-result"
                            max="100">
                            <b-progress-bar
                                variant="success"
                                :value="form.values.students.value"
                                :label="form.values.students.value + '%'"></b-progress-bar>
                        </b-progress>
                        <b-progress
                            class="skill-bar-result"
                            max="100">
                            <b-progress-bar
                                variant="warning"
                                :value="form.values.teachers.value"
                                :label="form.values.teachers.value + '%'"></b-progress-bar>
                        </b-progress>
                    </div>

                    <div class="col-2">
                        <b-button
                            class="btn-open btn-show-rubric remove-icon-margin"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            @click="showRubric(form)"
                            :title="$t('survey.view_rubric')">
                        </b-button>
                    </div>
                </div>
            </div>

            <design-2021-survey-results-index-rubric-modal-component
                ref="bars-rubric-details-modal"></design-2021-survey-results-index-rubric-modal-component>
        </div>
    </b-modal>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'design-2021-survey-results-index-bars-modal-component',
    components: {
        apexcharts: VueApexCharts,
    },
    data() {
        return {
            modal: false,
            skill: null,
            series: [],
            forms: [],
            chartOptions: {
                chart: {
                    height: '300px',
                    type: 'line',
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false,
                    },
                },
                colors: ['#07A1FF', '#61CC13', '#FFD600'],
                xaxis: {
                    type: 'category',
                },
                markers: {
                    size: 4,
                },
                stroke: {
                    curve: 'smooth',
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5,
                    },
                },
            },
        };
    },
    methods: {
        showRubric(value) {
            this.axios.get(this.routes.rubricFormModal(value.form_id)).then(
                (response) => {
                    this.$refs['bars-rubric-details-modal'].show(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show(skill) {
            this.series = [];
            this.forms = skill.forms.slice();

            this.series = this.forms.reduce((acc, form) => {
                if (!acc.length) {
                    acc = [
                        {
                            name: this.$t('survey.own'),
                            data: [],
                        },
                        {
                            name: this.$t('survey.students'),
                            data: [],
                        },
                        {
                            name: this.$t('survey.teachers'),
                            data: [],
                        },
                    ];
                }

                this.addDataToAccumulator(form.values.self.value, form.created_at, acc, this.$t('survey.own'));
                this.addDataToAccumulator(form.values.students.value, form.created_at, acc, this.$t('survey.students'));
                this.addDataToAccumulator(form.values.teachers.value, form.created_at, acc, this.$t('survey.teachers'));

                return acc;
            }, {});

            this.modal = true;
        },

        addDataToAccumulator(value, createdAt, formArray, name) {
            if (value !== null) {
                const chartData = {
                    x: this.moment(createdAt).format('D MMM'),
                    y: value,
                };

                const index = formArray.findIndex((el) => el.name === name);

                if (index !== -1) {
                    formArray[index].data.push(chartData);
                }
            }
        },
    },
};
</script>

<style scoped>
.skill-bar-result {
    margin-top: 5px;
}

.skill-bar {
    margin-bottom: 20px;
}

.btn {
    line-height: 75px;
}
</style>
